// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

import { LegacyBox } from "./LegacyBox";
import { CurvedTopper } from ".";

export default function CurvedGradientSection({
  topColor = "#f0f0f0",
  bottomColor = "#F0F0F000",
  animate,
  children = null,
}: {
  topColor?: string;
  bottomColor?: string;
  animate?: boolean;
  children?: React.ReactNode | null;
}) {
  return (
    <LegacyBox>
      <CurvedTopper animate={animate} color={topColor} />
      <LegacyBox
        sx={{
          backgroundImage: `linear-gradient(${topColor},${bottomColor})`,
          backgroundSize: "100% 275px",
          backgroundRepeat: "no-repeat",
        }}
      >
        {children}
      </LegacyBox>
    </LegacyBox>
  );
}
